import Token from "../config/token.service";
import { resetStores as resetUserStores } from "../config/user.stores";
import { resetStores as resetAdvertiserStores } from "../config/advertiser.stores";
import { resetStores as resetAdminStores } from "../config/admin.stores";

const resetAllStores = () => {
    resetUserStores();
    resetAdvertiserStores();
    resetAdminStores();
    Token.removeUser();
}

export default resetAllStores;
